var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.558,
    height: 25.16,
    viewBox: "0 0 30.558 25.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_72859",
    "data-name": "Group 72859",
    transform: "translate(0.201 0.024)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221521",
    "data-name": "Path 221521",
    d: "M18.283,15.141,13.141,10,8,15.141M13.141,10V21.568",
    transform: "translate(1.999 2.567)",
    fill: "none",
    stroke: "#0076c4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221522",
    "data-name": "Path 221522",
    d: "M25.924,20.781A6.427,6.427,0,0,0,22.852,8.711h-1.62a10.283,10.283,0,1,0-17.66,9.383",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#0076c4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221523",
    "data-name": "Path 221523",
    d: "M18.283,15.141,13.141,10,8,15.141",
    transform: "translate(1.999 2.567)",
    fill: "none",
    stroke: "#0076c4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataUpload);
export default __webpack_public_path__ + "static/media/data-upload.9b53b669f61ab9932a9ad5779d3c414d.svg";
export { ForwardRef as ReactComponent };